// extracted by mini-css-extract-plugin
module.exports = {"container__return":"styles_container__return__FI-A8"};